import {Map} from 'immutable';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

export default function (rates, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
            return Map();

        case LIVE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return init(Map(), action.data);

        case LineActions.SUCCESS_REQUEST_FULL_LINE: {
            const matches = action.data.events.add.map(m => { return {id: m.id}});
            //rates = removeEntities(rates, 'matchId', matches);
            rates = myRemoveEntities(rates, 'matchId', matches);
            return init(rates, action.data);
        }

        case LIVE_UPDATE.SUCCESS:
            return update(rates, action.data);
    }

    return rates;
}

function init(rates, data) {
    if (data.rates !== undefined) {
        rates = addRates(rates, data.rates.add);
    }

    if (data.blocked_events !== undefined && data.blocked_events.add !== undefined) {
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
    }

    if (data.blocked_outcomes !== undefined && data.blocked_outcomes.add !== undefined) {
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
    }

    return rates;
}

function update(rates, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        //rates = removeEntities(rates, 'sportId', data.sports.remove);
        rates = myRemoveEntitiesBySport(rates, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        //rates = removeEntities(rates, 'leagueId', data.leagues.remove);
        rates = myRemoveEntities(rates, 'leagueId', data.leagues.remove);
    }

    if (data.events !== undefined && data.events.remove !== undefined) {
        //rates = removeEntities(rates, 'matchId', data.events.remove);
        rates = myRemoveEntities(rates, 'matchId', data.events.remove);
    }

    if (data.outcomes !== undefined && data.outcomes.remove !== undefined) {
        //rates = removeEntities(rates, 'outcomeId', data.outcomes.remove);
        rates = myRemoveEntities(rates, 'outcomeId', data.outcomes.remove);
    }

    if (data.rates !== undefined) {
        if (data.rates.add !== undefined) {
            rates = addRates(rates, data.rates.add);
        }

        rates = changeRates(rates, data.rates.change);
    }

    if (data.blocked_events !== undefined) {
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.add, true);
        rates = updateRatesBlock(rates, 'matchId', data.blocked_events.remove, false);
    }

    if (data.blocked_outcomes !== undefined) {
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.add, true);
        rates = updateRatesBlock(rates, 'outcomeId', data.blocked_outcomes.remove, false);
    }

    return rates;
}

function addRates(rates, addRates) {
    if (addRates === undefined) {
        return rates;
    }

    return rates.withMutations(r => {
        for (let i = 0; i < addRates.length; i++) {
            const addRate = addRates[i];

            if (addRate === undefined || addRate.outcomeId === undefined) {
                throw new Error('Add rate: parent key not found');
            }

            const plainRate = Object.assign({}, addRate, {
                isVisible: addRate.value > 1,
                isBlocked: false
            });

            const rate = Map(plainRate);

            r.set(addRate.id, rate);
        }
    });
}

function changeRates(rates, changeRates) {
    if (changeRates === undefined) {
        return rates;
    }

    for (let rateId in changeRates) {
        if (!changeRates.hasOwnProperty(rateId)) {
            continue;
        }

        ((rateId, value) => {
            rates = rates.update(parseInt(rateId), (r) => {
                if (r === undefined) {
                    throw new Error('Rate#' + rateId + 'not present in state, but change received');
                }
                return r.set('value', value).set('isVisible', value > 1);
            });
        })(rateId, changeRates[rateId]);
    }

    return rates;
}

function updateRatesBlock(entities, field, values, isBlocked) {
    if (values === undefined) {
        return entities;
    }

    const affectedIds = entities.valueSeq()
        .filter(m => values.indexOf(m.get(field)) !== -1)
        .map(m => m.get('id'))
        .toArray();

    entities = entities.withMutations(e => {
        for (let j = 0; j < affectedIds.length; j++) {
            const id = affectedIds[j];
            e.setIn([id, 'isBlocked'], isBlocked);
        }
    });

    return entities;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/ratesReducer.js